import {
  limitedReleaseBySNConstants,
  createLimitedReleaseBySNConstants,
  editLimitedReleaseBySNConstants,
  addTargetLimitedReleaseBySNConstants,
  removeTargetLimitedReleaseBySNConstants,
  activateLimitedReleaseBySNConstants,
  deactivateLimitedReleaseBySNConstants,
  deleteLimitedReleaseBySNConstants,
} from "../_redux-constants/";

export function limitedReleasesSNReducer(
  state = {
    limitedReleaseBySNLoading: false,
    limitedReleaseBySNData: null,
    limitedReleaseBySNError: null,

    createLimitedReleaseBySNLoading: false,
    createLimitedReleaseBySNData: null,
    createLimitedReleaseBySNError: null,

    editLimitedReleaseBySNLoading: false,
    editLimitedReleaseBySNData: null,
    editLimitedReleaseBySNError: null,

    addTargetLimitedReleaseBySNLoading: false,
    addTargetLimitedReleaseBySNData: null,
    addTargetLimitedReleaseBySNError: null,

    removeTargetLimitedReleaseBySNLoading: false,
    removeTargetLimitedReleaseBySNData: null,
    removeTargetLimitedReleaseBySNError: null,

    activateLimitedReleaseBySNLoading: false,
    activateLimitedReleaseBySNData: null,
    activateLimitedReleaseBySNError: null,

    deactivateLimitedReleaseBySNLoading: false,
    deactivateLimitedReleaseBySNData: null,
    deactivateLimitedReleaseBySNError: null,

    deleteLimitedReleaseBySNLoading: false,
    deleteLimitedReleaseBySNData: null,
    deleteLimitedReleaseBySNError: null,
  },
  action
) {
  switch (action.type) {
    case limitedReleaseBySNConstants.LIMITED_RELEASE_BY_SN_LOADING:
      return Object.assign({}, state, {
        limitedReleaseBySNLoading: true,
        limitedReleaseBySNData: null,
        limitedReleaseBySNError: null,
      });
    case limitedReleaseBySNConstants.LIMITED_RELEASE_BY_SN_SUCCESS:
      return Object.assign({}, state, {
        limitedReleaseBySNLoading: false,
        limitedReleaseBySNData: action.data,
      });
    case limitedReleaseBySNConstants.LIMITED_RELEASE_BY_SN_FAILURE:
      return Object.assign({}, state, {
        limitedReleaseBySNLoading: false,
        limitedReleaseBySNData: null,
        limitedReleaseBySNError: action.error,
      });
    case createLimitedReleaseBySNConstants.CREATE_LIMITED_RELEASE_BY_SN_LOADING:
      return Object.assign({}, state, {
        createLimitedReleaseBySNLoading: true,
        createLimitedReleaseBySNData: null,
        createLimitedReleaseBySNError: null,
      });
    case createLimitedReleaseBySNConstants.CREATE_LIMITED_RELEASE_BY_SN_SUCCESS:
      return Object.assign({}, state, {
        createLimitedReleaseBySNLoading: false,
        createLimitedReleaseBySNData: action.data,
      });
    case createLimitedReleaseBySNConstants.CREATE_LIMITED_RELEASE_BY_SN_FAILURE:
      return Object.assign({}, state, {
        createLimitedReleaseBySNLoading: false,
        createLimitedReleaseBySNData: null,
        createLimitedReleaseBySNError: action.error,
      });
    case editLimitedReleaseBySNConstants.EDIT_LIMITED_RELEASE_BY_SN_LOADING:
      return Object.assign({}, state, {
        editLimitedReleaseBySNLoading: true,
        editLimitedReleaseBySNData: null,
        editLimitedReleaseBySNError: null,
      });
    case editLimitedReleaseBySNConstants.EDIT_LIMITED_RELEASE_BY_SN_SUCCESS:
      return Object.assign({}, state, {
        editLimitedReleaseBySNLoading: false,
        editLimitedReleaseBySNData: action.data,
      });
    case editLimitedReleaseBySNConstants.EDIT_LIMITED_RELEASE_BY_SN_FAILURE:
      return Object.assign({}, state, {
        editLimitedReleaseBySNLoading: false,
        editLimitedReleaseBySNData: null,
        editLimitedReleaseBySNError: action.error,
      });
    case addTargetLimitedReleaseBySNConstants.ADD_TARGET_LIMITED_RELEASE_BY_SN_LOADING:
      return Object.assign({}, state, {
        addTargetLimitedReleaseBySNLoading: true,
        addTargetLimitedReleaseBySNData: null,
        addTargetLimitedReleaseBySNError: null,
      });
    case addTargetLimitedReleaseBySNConstants.ADD_TARGET_LIMITED_RELEASE_BY_SN_SUCCESS:
      return Object.assign({}, state, {
        addTargetLimitedReleaseBySNLoading: false,
        addTargetLimitedReleaseBySNData: action.data,
      });
    case addTargetLimitedReleaseBySNConstants.ADD_TARGET_LIMITED_RELEASE_BY_SN_FAILURE:
      return Object.assign({}, state, {
        addTargetLimitedReleaseBySNLoading: false,
        addTargetLimitedReleaseBySNData: null,
        addTargetLimitedReleaseBySNError: action.error,
      });
    case removeTargetLimitedReleaseBySNConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_SN_LOADING:
      return Object.assign({}, state, {
        removeTargetLimitedReleaseBySNLoading: true,
        removeTargetLimitedReleaseBySNData: null,
        removeTargetLimitedReleaseBySNError: null,
      });
    case removeTargetLimitedReleaseBySNConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_SN_SUCCESS:
      return Object.assign({}, state, {
        removeTargetLimitedReleaseBySNLoading: false,
        removeTargetLimitedReleaseBySNData: action.data,
      });
    case removeTargetLimitedReleaseBySNConstants.REMOVE_TARGET_LIMITED_RELEASE_BY_SN_FAILURE:
      return Object.assign({}, state, {
        removeTargetLimitedReleaseBySNLoading: false,
        removeTargetLimitedReleaseBySNData: null,
        removeTargetLimitedReleaseBySNError: action.error,
      });
    case activateLimitedReleaseBySNConstants.ACTIVATE_LIMITED_RELEASE_BY_SN_LOADING:
      return Object.assign({}, state, {
        activateLimitedReleaseBySNLoading: true,
        activateLimitedReleaseBySNData: null,
        activateLimitedReleaseBySNError: null,
      });
    case activateLimitedReleaseBySNConstants.ACTIVATE_LIMITED_RELEASE_BY_SN_SUCCESS:
      return Object.assign({}, state, {
        activateLimitedReleaseBySNLoading: false,
        activateLimitedReleaseBySNData: action.data,
      });
    case activateLimitedReleaseBySNConstants.ACTIVATE_LIMITED_RELEASE_BY_SN_FAILURE:
      return Object.assign({}, state, {
        activateLimitedReleaseBySNLoading: false,
        activateLimitedReleaseBySNData: null,
        activateLimitedReleaseBySNError: action.error,
      });
    case deactivateLimitedReleaseBySNConstants.DEACTIVATE_LIMITED_RELEASE_BY_SN_LOADING:
      return Object.assign({}, state, {
        deactivateLimitedReleaseBySNLoading: true,
        deactivateLimitedReleaseBySNData: null,
        deactivateLimitedReleaseBySNError: null,
      });
    case deactivateLimitedReleaseBySNConstants.DEACTIVATE_LIMITED_RELEASE_BY_SN_SUCCESS:
      return Object.assign({}, state, {
        deactivateLimitedReleaseBySNLoading: false,
        deactivateLimitedReleaseBySNData: action.data,
      });
    case deactivateLimitedReleaseBySNConstants.DEACTIVATE_LIMITED_RELEASE_BY_SN_FAILURE:
      return Object.assign({}, state, {
        deactivateLimitedReleaseBySNLoading: false,
        deactivateLimitedReleaseBySNData: null,
        deactivateLimitedReleaseBySNError: action.error,
      });
    case deleteLimitedReleaseBySNConstants.DELETE_LIMITED_RELEASE_BY_SN_LOADING:
      return Object.assign({}, state, {
        deleteLimitedReleaseBySNLoading: true,
        deleteLimitedReleaseBySNData: null,
        deleteLimitedReleaseBySNError: null,
      });
    case deleteLimitedReleaseBySNConstants.DELETE_LIMITED_RELEASE_BY_SN_SUCCESS:
      return Object.assign({}, state, {
        deleteLimitedReleaseBySNLoading: false,
        deleteLimitedReleaseBySNData: action.data,
      });
    case deleteLimitedReleaseBySNConstants.DELETE_LIMITED_RELEASE_BY_SN_FAILURE:
      return Object.assign({}, state, {
        deleteLimitedReleaseBySNLoading: false,
        deleteLimitedReleaseBySNData: null,
        deleteLimitedReleaseBySNError: action.error,
      });
    default:
      return state;
  }
}
